<template>
  <section>
    <contact-section/>
    <start-section/>
    <about-section/>
    <advantages-section/>
    <how-it-works-section/>
  </section>
</template>

<script>
import AboutSection from "@/pages/home/AboutSection";
import AdvantagesSection from "@/pages/home/AdvantagesSection";
import HowItWorksSection from "@/pages/home/HowItWorksSection";
import ContactSection from "@/pages/home/ContactSection";
import StartSection from "@/pages/home/StartSection";

export default {
  name: 'HomePage',
  components: {StartSection, ContactSection, HowItWorksSection, AdvantagesSection, AboutSection},
}
</script>
